import React, { useState, useRef, useEffect, useContext } from "react";
import '../StockCard/StockCard.css'
import URLstateContext from "../../../provider/CommonContext";


function StockCard() {
    const [data, setData] = useState(false);
    const { BaseLiveURL } = useContext(URLstateContext);
    const [nodatafound, setnodatafound] = useState(false);
    useEffect(() => {
        postData('/api/Login/MarketBanner', { Caption: "Stocks" })
            .then((data) => {
                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }

    const images = data &&
        data.map(image => {
            return (
                <a href={image.bannerUrl} target="_blank">
                <img key={image.uploadfile} src={BaseLiveURL + "marketimages/" + image.uploadfile} className="img-responsive moreContent" />
                </a>
            )});

                    return (
                    <>
                        <div className='market-right-sc Stock-Market'>
                            {images}
                            {nodatafound &&
                                <p className="textcenter nodata">No Image found !!!</p>
                            }
                            {/* <div className="rechrsnglsidebar_pricegridA">
                    <h2>We won't let your Margin sit idle.</h2>
                    <div className="rechrsnglsidebar_pricegroup mt-4 d-flex justify-content-between">
                        <div className="marginprice_box marginprice_20box">
                            <h3><i className="fa fa-rupee"></i><span>20</span><span className="rechrsnglsidebar_plan">
                                <small>Plan</small> A</span></h3><p>Per order + interest on ledger balance + Zero delivery Brokerage</p>
                        </div>
                        <div className="marginprice_box marginprice_10box"><h3><i className="fa fa-rupee"></i><span>10</span>
                            <span className="rechrsnglsidebar_plan"><small>Plan</small> B</span></h3><p>Per order only (No hidden charges)</p>
                        </div>
                    </div>
                    <p className="termconditions_text">*<a href="/TermsCondition">T&amp;C</a> apply.</p>
                    <div className='market-btn'>
                        <a href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank" className="btn btn-primary">Get Started</a>
                    </div>
                </div> */}
                        </div>
                    </>
                    )
}

                    export default StockCard